import _defineProperty from "/u01/jenkins/workspace/MGMW_dev_masterbuild_appweb-Final/mgmw_ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/u01/jenkins/workspace/MGMW_dev_masterbuild_appweb-Final/mgmw_ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["mode", "children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
export var TxButtonMode;

(function (TxButtonMode) {
  TxButtonMode["Primary"] = "primary";
  TxButtonMode["Secondary"] = "secondary";
  TxButtonMode["Tertiary"] = "tertiary";
  TxButtonMode["Danger"] = "danger";
})(TxButtonMode || (TxButtonMode = {}));

export function TxButton(_ref) {
  var _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? TxButtonMode.Primary : _ref$mode,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var extraClass = className ? " ".concat(className) : '';
  return React.createElement("button", _objectSpread(_objectSpread({}, props), {}, {
    className: 'tx-btn tx-btn--' + mode + extraClass
  }), children);
}